import type { SortOption } from '@/shared/types/common';
import type { SortByOption } from '@/shared/types/options';

/**
 * SortBy를 SortOption으로 변환합니다.
 *
 * @param sortBy - 변환할 SortBy 값
 * @returns SortOption 객체
 */
export const getTransformSortByToSortOption = (sortBy: SortByOption): SortOption => {
  if (sortBy === 'name') {
    return {
      field: 'displayName.keyword',
      direction: 'asc',
    };
  }

  if (sortBy === 'lastUpdatedAsc') {
    return {
      field: 'updatedAt',
      direction: 'asc',
    };
  }

  return {
    field: 'updatedAt',
    direction: 'desc',
  };
};
